import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./services/auth/auth.guard";

const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "" },
  {
    path: "auth",
    loadChildren: () => import("./pages/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    canActivate: [AuthGuard],
    path: "",
    loadChildren: () => import("./pages/dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      relativeLinkResolution: "legacy",
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
